import type { RejectedScan } from '../../../services/dmRejectedScans';

export const REVIEW_LABELS: Record<RejectedScan['review'], string> = {
    refused: 'Refused',
    rejected: 'Rejected'
};

function capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

// DM sends scan types as identifiers like 'planning'; underscores read as spaces.
export function scanTypeLabel(type: string | null): string | null {
    const words = (type ?? '').split(/[\s_]+/).filter(Boolean);
    return words.length > 0 ? words.map(capitalize).join(' ') : null;
}

export function rejectionReasonLine(reasons: readonly string[]): string | null {
    return reasons.length > 0 ? `Rejection reason: ${reasons.join(', ')}` : null;
}

export function truncatedListNote(shown: number, total: number): string | null {
    return total > shown ? `Showing the ${shown} most recent of ${total}` : null;
}

function plural(count: number, noun: string): string {
    return `${count} ${noun}${count === 1 ? '' : 's'}`;
}

export const PHOTOS_UNAVAILABLE = 'Photos unavailable';

export function scanPhotoSummary({
    views,
    photosUnavailable
}: Pick<RejectedScan, 'views' | 'photosUnavailable'>): string {
    if (photosUnavailable) return PHOTOS_UNAVAILABLE;
    const photoCount = views.reduce((sum, view) => sum + view.photos.length, 0);
    return photoCount === 0
        ? 'No photos'
        : `${plural(views.length, 'view')} · ${plural(photoCount, 'photo')}`;
}
